import { DescribeProperty, ZitadelRole } from '../../common';

export class SubscriptionRefreshRolesResponse {
  @DescribeProperty({
    description: 'The list of roles user should be granted',
  })
  roleKeys: ZitadelRole[];
}
